import { z } from "zod";

export const completeTaskSchema = z.object({
    note: z.string(),
    tag: z.string(),
});

export const completeTaskSchemaNoTag = z.object({
    note: z.string(),
    saveType: z.string(),
});
